import axios, { AxiosResponse } from 'axios'

import { setApiUrl } from 'api/helpers'
import { getCsrfToken } from '../getCsrfToken'

import { RESOURCE_ENDPOINT } from './config'
import { TPostFeedbackPayload, TPostFeedbackResponse } from "./types";

export const postFeedback = async (
  payload: TPostFeedbackPayload
): Promise<AxiosResponse<TPostFeedbackResponse>> => {
  const url = setApiUrl(RESOURCE_ENDPOINT)

  const { data: tokenData } = await getCsrfToken()
  const { headerName, token } = tokenData

  return axios.post<TPostFeedbackResponse>(url, JSON.stringify(payload), {
    headers: {
      [headerName]: token,
      'Content-Type': 'application/json',
    },
  })
}
